// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6j-0";
export var startPickingButton = "_6j-1";